import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "py-4 container-fluid" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-12" }
const _hoisted_4 = { class: "col-12" }
const _hoisted_5 = { class: "dataTable-bottom" }
const _hoisted_6 = { class: "dataTable-info" }
const _hoisted_7 = { class: "dataTable-pagination" }
const _hoisted_8 = { class: "dataTable-pagination-list" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("a", { href: "#" }, "‹", -1)
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = ["onClick"]
const _hoisted_12 = { href: "#" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("a", { href: "#" }, "›", -1)
const _hoisted_14 = [
  _hoisted_13
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_formulario_veiculo = _resolveComponent("formulario-veiculo")!
  const _component_veiculos_table = _resolveComponent("veiculos-table")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_ctx.veiculo.id != '-')
          ? (_openBlock(), _createBlock(_component_formulario_veiculo, {
              key: 0,
              veiculo: _ctx.veiculo,
              operacoes: _ctx.operacoes,
              salvarVeiculo: _ctx.salvarVeiculo,
              fecharVeiculo: _ctx.fecharVeiculo
            }, null, 8, ["veiculo", "operacoes", "salvarVeiculo", "fecharVeiculo"]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_veiculos_table, {
          rows: _ctx.rows,
          salvarVeiculo: _ctx.salvarVeiculo,
          getVeiculo: _ctx.getVeiculo
        }, null, 8, ["rows", "salvarVeiculo", "getVeiculo"]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.current_page * 10 + 1) + " até " + _toDisplayString(Math.min((_ctx.current_page + 1) * 10, _ctx.total_count)) + " de " + _toDisplayString(_ctx.total_count) + " Veículos ", 1),
          _createElementVNode("nav", _hoisted_7, [
            _createElementVNode("ul", _hoisted_8, [
              _createElementVNode("li", {
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.getPaginas(Math.max((_ctx.current_page - 1) * 10, 0)))),
                class: _normalizeClass(["pager", { disabled: _ctx.current_page === 0 }])
              }, _hoisted_10, 2),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.total_pages, (page) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: page,
                  onClick: ($event: any) => (_ctx.getPaginas((page - 1) * 10)),
                  class: _normalizeClass({ active: _ctx.current_page === (page - 1) })
                }, [
                  _createElementVNode("a", _hoisted_12, _toDisplayString(page), 1)
                ], 10, _hoisted_11))
              }), 128)),
              _createElementVNode("li", {
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.getPaginas(Math.min((_ctx.current_page + 1) * 10, (_ctx.total_pages - 1) * 10)))),
                class: _normalizeClass(["pager", { disabled: _ctx.current_page === _ctx.total_pages - 1 }])
              }, _hoisted_14, 2)
            ])
          ])
        ])
      ])
    ])
  ]))
}